export default "__VITE_ASSET__8d9c912c__"